import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import { toast } from 'react-toastify';

import SpinnerBlock from '../../../common/SpinnerBlock';

import { showModal } from '../../../../actions/modal';
import { fetchUpdateWorksheet } from '../../../../actions/orders';

import { checkOrderConfirmation, parseError } from '../../../../helpers';
import Checkbox from './../../../common/Checkbox';
import {
  editCurrentSupply,
  fetchGetSupplyWorksheet,
  fetchGetSupplyWorksheetFormTemplate,
  fetchUpdateSupplyWorksheet,
} from '../../../../actions/supplies';
import Radios from '../../../common/Radios';
import Select from '../../../common/Select';
import TextArea from '../../../common/TextArea';

const Wrapper = styled('div')`
  position: relative;
  padding-left: 0;
  padding-right: 0;

  > div {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 24px;
    &:last-child {
      padding-bottom: 0;
    }
  }
  .block-subtitle {
    margin-bottom: 8px;
  }

  .card-title {
    padding-top: 4px;
    padding-bottom: 23px;
    align-items: center;
    h4 {
      font-size: 16px;
      margin: 0;
    }
  }

  .file-type-toggle {
    margin: -15px 0 20px 0;
  }
`;

const FieldWrapper = styled('div')`
  .file-type-toggle {
    margin: -10px 0 20px;
  }

  .dropzone {
    display: flex;
    align-items: center;
    padding: 5px;
    min-height: 100px;
    cursor: pointer;
    background-color: #ffffff;
    border: 2px dashed rgba(50, 58, 70, 0.3);

    &.with-text {
      width: 100%;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
      transition-duration: 0.3s;
    }
  }

  .selected-file {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5px;
    min-height: 100px;
    background-color: #f1f5f7;
    border-radius: 0.2rem;
    position: relative;

    .selected-file-name {
      text-decoration: underline;
    }

    .selected-file-close {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 1.4rem;
      padding: 5px 10px;
      font-weight: 700;
      line-height: 1;
      color: #000;
      opacity: 0.5;
      cursor: pointer;

      :hover {
        opacity: 1;
      }
    }

    .file-type-toggle {
      margin: -15px 0 20px 0;
    }

    .textarea-wrapper {
      input {
        resize: none;
      }
    }
  }
`;

const PDF = '.pdf';
const EXCEL = '.xls';

export const findElementValue = (array, string) => {
  return array.find((item) => item.id === string)?.title;
};

export const Field = (props) => {
  const { id, value, formData, disabled, handleChange } = props;

  const currentField = formData && formData.find((f) => f.id === id);
  const currentValue = value ? value : '';
  const [selectValue, setSelectValue] = useState(null);

  const options = (currentField) => {
    if (currentField.inputType === 'MULTI') {
      return currentField.availableValues?.map((item) => ({ ...item, label: item.title }));
    } else {
      return [];
    }
  };

  const FieldValueComponent = () => {
    if (currentField?.id === 'require_individual_additional_packing') {
      return (
        <Checkbox
          label={'Индивидуальная доп. упаковка товара'}
          checked={currentField?.value}
          disabled
        />
      );
    } else if (currentField?.id === 'use_factory_master_boxes') {
      return <Checkbox checked={currentField?.value} label={currentField.name} disabled />;
    } else if (currentField?.inputType === 'CHECKBOX') {
      return (
        <Checkbox
          type="checkbox"
          checked={currentValue?.value === 'true'}
          label={currentField?.name}
          disabled={disabled}
          onChange={(e) => handleChange(e, id, 'CHECKBOX')}
        />
      );
    } else if (currentField?.inputType === 'MULTI') {
      return (
        <Select
          id={currentField?.id}
          name={currentField?.name}
          options={options(currentField)}
          value={{
            label: findElementValue(currentField?.availableValues, currentValue?.value),
            value: currentValue?.value,
          }}
          onChange={(e) => setSelectValue(e)}
          isDisabled
        />
      );
    } else {
      return <div>{currentValue ? currentValue : <i>Данные не заполнены</i>}</div>;
    }
  };

  return (
    <FieldWrapper>
      <div key={id} className="fbo-item">
        <FieldValueComponent />
      </div>
    </FieldWrapper>
  );
};

const WorksheetBlock = (props) => {
  const { isNew, currentSupply } = props;

  const dispatch = useDispatch();

  const [formData, setFormData] = useState(null);
  const [fields, setFields] = useState(null);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async function () {
      setLoading(true);

      await dispatch(fetchGetSupplyWorksheetFormTemplate(currentSupply.id)).then((res) => {
        setFormData(res.form_content);
      });
      await dispatch(fetchGetSupplyWorksheet(currentSupply.id)).then((res) => {
        setFields(res);
      });

      setLoading(false);
    })();
  }, [currentSupply]);

  return (
    <>
      {fields ? (
        <>
          {formData.map((f, index) => (
            <>
              <Field
                key={f.id}
                {...f}
                formData={formData}
                currentOrder={currentSupply}
                value={fields[index]}
              />

              <div className="textarea-wrapper">
                <TextArea value={fields[index]?.comment || ''} disabled resize="none" />
              </div>
            </>
          ))}
        </>
      ) : null}
    </>
  );
};

export default WorksheetBlock;
